// Comprehensive city/location list sourced from the backend's messagePreFilter.js
// `this.locations` array — the same data the AI uses to parse ride messages.
// Capitals intentional to match how they appear in ride listings.

export const ALL_CITIES: string[] = [
  // Default suggestions shown first (user-configured)
  'Mohali', 'Chandigarh', 'Delhi', 'Manali', 'Shimla', 'Amritsar',
  // Chandigarh tricity
  'Panchkula', 'Zirakpur', 'Kharar',
  // Punjab
  'Ludhiana', 'Jalandhar', 'Patiala', 'Bathinda', 'Pathankot',
  'Barnala', 'Nabha', 'Sangrur', 'Rajpura', 'Sirhind', 'Fatehgarh Sahib',
  'Gobindgarh', 'Moga', 'Firozpur', 'Khanna', 'Gurdaspur', 'Hoshiarpur',
  'Ropar', 'Morinda', 'Malerkotla', 'Phagwara', 'Muktsar', 'Faridkot',
  'Zira', 'Nakodar', 'Mullapur',
  // Himachal Pradesh
  'Kasol', 'Kullu', 'Mandi', 'Dharamshala', 'Kangra', 'Palampur',
  'Dalhousie', 'Chamba', 'Khajjiar', 'Kasauli', 'Solan', 'Nahan',
  'Bilaspur', 'Hamirpur', 'Una', 'Kufri', 'Baddi', 'Parwanoo',
  // Uttarakhand
  'Dehradun', 'Haridwar', 'Rishikesh', 'Haldwani', 'Nainital',
  'Mussoorie', 'Roorkee', 'Jolly Grant', 'Jim Corbett', 'Ramnagar',
  'Mukteshwar', 'Tehri', 'Uttarkashi', 'Gangotri', 'Badrinath',
  'Kedarnath', 'Auli', 'Almora', 'Ranikhet', 'Pithoragarh',
  // Delhi NCR
  'Noida', 'Gurgaon', 'Faridabad', 'Ghaziabad', 'Agra', 'Mathura',
  'Meerut', 'Aligarh', 'Moradabad', 'Saharanpur',
  // J&K
  'Jammu', 'Katra', 'Udhampur', 'Srinagar', 'Gulmarg', 'Pahalgam',
  'Sonamarg', 'Leh', 'Ladakh',
  // Haryana
  'Ambala', 'Karnal', 'Kurukshetra', 'Yamunanagar', 'Panipat',
  'Rohtak', 'Hisar', 'Sirsa', 'Kaithal', 'Sonipat', 'Rewari', 'Kalka',
  // Rajasthan
  'Jaipur', 'Udaipur', 'Jodhpur', 'Ajmer', 'Pushkar', 'Kota',
  'Bhilwara', 'Alwar', 'Bikaner', 'Jaisalmer', 'Mount Abu',
  'Kishangarh', 'Beawar', 'Nasirabad',
  // UP
  'Varanasi', 'Kanpur', 'Lucknow', 'Allahabad', 'Prayagraj',
  'Gorakhpur', 'Ayodhya',
  // Metros
  'Mumbai', 'Bangalore', 'Bengaluru', 'Hyderabad', 'Chennai',
  'Kolkata', 'Pune', 'Ahmedabad', 'Surat',
  // Gujarat
  'Vadodara', 'Gandhinagar', 'Rajkot', 'Bhuj', 'Dwarka',
  // Maharashtra
  'Nashik', 'Nagpur', 'Aurangabad', 'Shirdi', 'Lonavala',
  'Mahabaleshwar', 'Kolhapur',
  // Karnataka
  'Mysore', 'Mangalore', 'Hubli', 'Belgaum',
  // Andhra/Telangana
  'Visakhapatnam', 'Vijayawada', 'Tirupati', 'Warangal',
  // Tamil Nadu / Kerala
  'Coimbatore', 'Madurai', 'Kochi', 'Thiruvananthapuram', 'Kozhikode',
  // Others
  'Bhopal', 'Indore', 'Gwalior', 'Patna', 'Ranchi', 'Bhubaneswar',
  'Guwahati', 'Siliguri', 'Darjeeling', 'Gangtok', 'Goa',
];

// The 6 cities shown upfront before any typing (user-configured defaults)
export const DEFAULT_CITY_SUGGESTIONS = ALL_CITIES.slice(0, 6);

/** Returns matching cities filtered by `query`, excluding already-selected ones. */
export function suggestCities(query: string, selected: string[], max = 10): string[] {
  const q = query.toLowerCase().trim();
  const matches = q === ''
    ? ALL_CITIES
    : [
        ...ALL_CITIES.filter((c) => c.toLowerCase().startsWith(q)),
        ...ALL_CITIES.filter((c) => {
          const value = c.toLowerCase();
          return value.includes(q) && !value.startsWith(q);
        }),
      ];
  return Array.from(new Set(matches))
    .filter((c) => !selected.includes(c))
    .slice(0, max);
}
